import React, { useState, useEffect, useRef } from 'react';

export const letterScores = {
    A: 2, B: 4, C: 3, D: 4, E: 2,
    F: 5, G: 4, H: 3, I: 2, J: 10,
    K: 6, L: 3, M: 4, N: 3, O: 2,
    P: 4, Q: 15, R: 3, S: 3, T: 3,
    U: 2, V: 6, W: 5, X: 12, Y: 5,
    Z: 20
};
